import SiteFooter from '@/components/SiteFooter';
import PublicHeader from '@/components/PublicHeader';
import { SITE } from '@/content/site';
import { useHeadMeta } from '@/lib/head';
import privacy from '@/content/legal/privacy.json';
import terms from '@/content/legal/terms.json';
import cookies from '@/content/legal/cookies.json';
import acceptableUse from '@/content/legal/acceptable-use.json';
import './Homepage.css';
import './HomepageFonts.css';

const documents = { 'Privacy Policy': privacy, 'Terms of Service': terms, 'Cookie Policy': cookies, 'Acceptable Use Policy': acceptableUse };
function PolicyText({ text }) {
  // Links stop before trailing punctuation, so "…/contact." links to /contact.
  return text.split(/(https:\/\/[^\s]*[^\s.,;:)]|www\.seo-signals\.com)/g).map((part, i) => /^https:\/\//.test(part) || part === 'www.seo-signals.com' ? <a key={i} href={part.startsWith('https:') ? part : `https://${part}`}>{part}</a> : part);
}
export default function PolicyPage({ title }) {
  useHeadMeta({ title: `${title} | SEO Signals`, robots: 'noindex, follow' });
  const document = documents[title];
  return <div className="ss-home ss-uc"><PublicHeader />
    <main className="ss-container ss-policy ss-legal-document"><p className="ss-eyebrow">Legal documents</p><h1>{document.title}</h1>
      {document.blocks.map((block, index) => block.type === 'heading' ? <h2 key={index}>{block.text}</h2> : <p key={index}><PolicyText text={block.text} /></p>)}
      <hr /><p>Contact SEO Signals: <a href={`mailto:${SITE.contactEmail}`}>{SITE.contactEmail}</a> · <a href="/contact">Contact page</a></p>
    </main><SiteFooter /></div>;
}
